import React, { useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Placeholder from 'react-bootstrap/Placeholder';
import "./Task.css";
import { BsCheckLg } from "react-icons/bs";
import Nav from 'react-bootstrap/Nav';
import { RiKeyboardBoxFill } from 'react-icons/ri';
import { BsImages } from 'react-icons/bs';
import { BsTable } from 'react-icons/bs';
import Table from 'react-bootstrap/Table';
import { CgCalendarDates } from 'react-icons/cg';
import { MdDriveFileRenameOutline } from 'react-icons/md';
function Task(props) {
  let { apiTask } = props;
  return (
    <div>
      <Card className="card">
        <Card.Body>
          <Card.Text>
            <br></br> <br></br>
            <h1><BsCheckLg /> {apiTask?.title}</h1>
            {apiTask?.description}
            <br></br> <br></br>
            <Nav variant="pills">
              <Nav.Item>
                <Nav.Link eventKey="/Board View"> <RiKeyboardBoxFill />&nbsp;Board View</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="/Galllery"><BsImages />&nbsp;Gallery</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="/Table"><BsTable />&nbsp;Table</Nav.Link>
              </Nav.Item>
              <Nav.Item>
              </Nav.Item>
            </Nav>

            <Table className='table'>
              <thead>
                <tr>
                  {/* <th>#</th> */}
                  <th><MdDriveFileRenameOutline />Name</th>
                  <th><CgCalendarDates /> Date</th>
                  <th>Date created</th>
                </tr>
              </thead>
              <tbody>
                {apiTask?.tasks?.map((item, index) => <tr key={index}>
                  {/* <td>1</td> */}
                  <td>{item}</td>
                  <td>Otto</td>
                  <td>@mdo</td>
                </tr>)}
              </tbody>
            </Table>
          </Card.Text>
        </Card.Body>
      </Card>
    </div>
  )
}

export default Task;